var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSparkleMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8362 13.7102L9.33622 17.7806C9.29182 17.9002 9.21188 18.0033 9.10714 18.0762C9.0024 18.149 8.87787 18.1881 8.75028 18.1881C8.6227 18.1881 8.49817 18.149 8.39343 18.0762C8.28868 18.0033 8.20874 17.9002 8.16435 17.7806L6.66435 13.7102C6.63269 13.6243 6.58277 13.5463 6.51802 13.4816C6.45328 13.4168 6.37526 13.3669 6.28935 13.3352L2.21903 11.8352C2.09942 11.7908 1.99626 11.7109 1.92342 11.6062C1.85057 11.5014 1.81152 11.3769 1.81152 11.2493C1.81152 11.1217 1.85057 10.9972 1.92342 10.8924C1.99626 10.7877 2.09942 10.7078 2.21903 10.6634L6.28935 9.16337C6.37526 9.13171 6.45328 9.08179 6.51802 9.01705C6.58277 8.9523 6.63269 8.87428 6.66435 8.78837L8.16435 4.71806C8.20874 4.59845 8.28868 4.49529 8.39343 4.42244C8.49817 4.34959 8.6227 4.31055 8.75028 4.31055C8.87787 4.31055 9.0024 4.34959 9.10714 4.42244C9.21188 4.49529 9.29182 4.59845 9.33622 4.71806L10.8362 8.78837C10.8679 8.87428 10.9178 8.9523 10.9825 9.01705C11.0473 9.08179 11.1253 9.13171 11.2112 9.16337L15.2815 10.6634C15.4011 10.7078 15.5043 10.7877 15.5771 10.8924C15.65 10.9972 15.689 11.1217 15.689 11.2493C15.689 11.3769 15.65 11.5014 15.5771 11.6062C15.5043 11.7109 15.4011 11.7908 15.2815 11.8352L11.2112 13.3352C11.1253 13.3669 11.0473 13.4168 10.9825 13.4816C10.9178 13.5463 10.8679 13.6243 10.8362 13.7102Z",
    stroke: "#3D464D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 1.25V5",
    stroke: "#3D464D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 3.125H11.875",
    stroke: "#3D464D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 5.625V8.125",
    stroke: "#3D464D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 6.875H16.25",
    stroke: "#3D464D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkleMobile);
export default __webpack_public_path__ + "static/media/sparkleMobile.5d20ae5712eb29382b0eb0971790920b.svg";
export { ForwardRef as ReactComponent };